import { nb } from '@/i18n/nb';

/*
 * The eight portal modules in landing order. `ownerOnly` gates Eierseksjon to
 * owner/admin — the flag exists now but isn't enforced until Iter 3 (auth);
 * Iter 2 renders all eight as shells. Cards are text-only (GATE 1 defect 01),
 * so there's no icon field — re-add one if a future surface (map/admin) needs it.
 */
export type ModuleId =
  | 'om-hytta'
  | 'utforsk'
  | 'gjestebok'
  | 'galleri'
  | 'vedlikehold'
  | 'regler'
  | 'eier'
  | 'faq';

export type ModuleDef = {
  id: ModuleId;
  title: string;
  desc: string;
  ownerOnly?: boolean;
};

export const MODULES: ModuleDef[] = [
  { id: 'om-hytta', title: nb.modules.omHytta.title, desc: nb.modules.omHytta.desc },
  { id: 'utforsk', title: nb.modules.utforsk.title, desc: nb.modules.utforsk.desc },
  { id: 'gjestebok', title: nb.modules.gjestebok.title, desc: nb.modules.gjestebok.desc },
  { id: 'galleri', title: nb.modules.galleri.title, desc: nb.modules.galleri.desc },
  { id: 'vedlikehold', title: nb.modules.vedlikehold.title, desc: nb.modules.vedlikehold.desc },
  { id: 'regler', title: nb.modules.regler.title, desc: nb.modules.regler.desc },
  { id: 'eier', title: nb.modules.eier.title, desc: nb.modules.eier.desc, ownerOnly: true },
  { id: 'faq', title: nb.modules.faq.title, desc: nb.modules.faq.desc },
];
